// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__MzSXp","main":"Footer_main__GTlmk"};